export default __webpack_public_path__ + "static/media/penydrop@2x.68fc98c4.png";